<template>
    <DsCard class="empty-state-card">
        <div class="go-daddy-logo">
            <img
                src="/resources/svg/go-daddy-logo.svg"
            />
        </div>

        <h3>{{ $t('email.auth.goDaddyCard.header') }}</h3>

        <p>{{ $t('email.auth.goDaddyCard.body') }}</p>

        <DsOutlineButton
            target="_blank"
            as="a"
            href="https://click.godaddy.com/affiliate?isc=cjcfos3&url=https://www.godaddy.com/offers/domain"
        >
            <template #trailing>
                <DsIcon
                    name="external-link"
                />
            </template>
            {{ $t('email.auth.goDaddyCard.externalLinkButton') }}
        </DsOutlineButton>
    </DsCard>
</template>

<script>
export default {
    emits: [
        'add-email-auth',
    ],
    methods: {
        addEmailAuth() {
            this.$emit('add-email-auth');
        },
    },
};
</script>

<style lang="scss" scoped>
.empty-state-card {
    padding: $spacing-200;
    margin: $spacing-200 0;
}

.go-daddy-logo {
    display: flex;
    height: px-to-rem(72);
    align-items: center;
}
</style>
